import React from "react";
import { Context } from "../context";
import { Helmet } from "react-helmet";
import decodeHTMLEntities from "../../utils/decodeHTMLentities";
const SEO = (props) => {
    const { seo, infos } = props;
    // const { wp, sitePlugin } = useStaticQuery(query);
    const context = React.useContext(Context);
    const displayTime = (time) => {
        return context.seo.timeFormat === "0" ? time.split("T")[0] : time;
    };
    let title = context.settings.general.title;
    const separator = " " + (context.seo.separator || "—") + " ";
    if (seo.title) {
        title = seo.title;
    }
    else if (infos.title) {
        title += separator + infos.title;
    }
    title = decodeHTMLEntities(title);
    const twTitle = decodeHTMLEntities(seo.twitterTitle || infos.title || context.settings.general.title);
    const ogTitle = decodeHTMLEntities(seo.openGraphTitle || infos.title || context.settings.general.title);
    const description = decodeHTMLEntities(seo.description || context.settings.general.description);
    const twDescription = decodeHTMLEntities(seo.twitterDescription ||
        seo.description ||
        context.settings.general.description);
    const ogDescription = decodeHTMLEntities(seo.openGraphDescription ||
        seo.description ||
        context.settings.general.description);
    const trackingScript = [
        ...(context.settings.general.advancedSettings.trackingCode || "").matchAll(/<script.*?>([\s\S]*?)<\/script>/g),
    ].map((e) => e[1]);
    const trackingNoScript = [
        ...(context.settings.general.advancedSettings.trackingCode || "").matchAll(/<noscript>([\s\S]*?)<\/noscript>/g),
    ].map((e) => e[1]);
    const image = {
        src: context.seo.rootUrl.slice(0, -1),
        width: 0,
        height: 0,
        alt: "",
    };
    image.src += (seo.socialImage || context.settings.general.themeSettings.siteLogo).localFile.childImageSharp.gatsbyImageData.images.fallback.src;
    image.width = (seo.socialImage || context.settings.general.themeSettings.siteLogo).localFile.childImageSharp.gatsbyImageData.width;
    image.height = (seo.socialImage || context.settings.general.themeSettings.siteLogo).localFile.childImageSharp.gatsbyImageData.height;
    image.alt = seo.socialImage && seo.socialImage.altText;
    let robots = [];
    (seo.noIndex === "1" || context.seo.siteNoIndex) && robots.push("noindex");
    (!context.seo.siteNoIndex && seo.noIndex) === "-1" && robots.push("index");
    (seo.noArchive || context.seo.siteNoArchive) && robots.push("noarchive");
    seo.noFollow && robots.push("nofollow");
    return (React.createElement(Helmet, { htmlAttributes: {
            "data-menu": props.menuState,
            lang: context.settings.general.language.replace("_", "-") || "fr",
        } },
        React.createElement("title", null, title),
        typeof context.settings.manifestOptions.icons !== "undefined" &&
            context.settings.manifestOptions.icons.length && (React.createElement("link", { rel: "icon", type: "image/png", href: "/favicon-32x32.png" })),
        typeof context.settings.manifestOptions.icons !== "undefined" &&
            context.settings.manifestOptions.icons.length && (React.createElement("link", { rel: "shortcut icon", type: "image/png", href: "/favicon-32x32.png" })),
        typeof context.settings.manifestOptions.icons !== "undefined" &&
            context.settings.manifestOptions.icons.length && (React.createElement("link", { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" })),
        robots.length && React.createElement("meta", { name: "robots", content: robots.join(", ") }),
        React.createElement("meta", { name: "description", content: description }),
        context.seo.showPublishedDate && infos.postType === "post" && (React.createElement("meta", { property: "article:published_time", content: displayTime(infos.published) })),
        context.seo.showModifiedDate && infos.postType === "post" && (React.createElement("meta", { property: "article:modified_time", content: displayTime(infos.updated) })),
        context.seo.themeColor.length && (React.createElement("meta", { name: "theme-color", content: context.seo.themeColor })),
        robots.indexOf("noindex") < 0 && (React.createElement("link", { rel: "canonical", href: seo.canonicalUrl || context.seo.rootUrl })),
        React.createElement("meta", { property: "og:image", content: image.src }),
        React.createElement("meta", { property: "og:image:width", content: image.width }),
        React.createElement("meta", { property: "og:image:height", content: image.height }),
        image.alt && React.createElement("meta", { property: "og:image:alt", content: image.alt }),
        React.createElement("meta", { property: "og:locale", content: context.settings.general.language || "fr_FR" }),
        React.createElement("meta", { property: "og:type", content: infos.postType === "post" ? "article" : "website" }),
        React.createElement("meta", { property: "og:url", content: seo.canonicalUrl || context.seo.rootUrl }),
        React.createElement("meta", { property: "og:site_name", content: context.settings.general.title }),
        React.createElement("meta", { property: "og:title", content: ogTitle }),
        React.createElement("meta", { property: "og:description", content: ogDescription }),
        context.seo.showModifiedDate && infos.postType === "post" && (React.createElement("meta", { property: "og:updated_time", content: displayTime(infos.updated) })),
        context.seo.fbAuthor && infos.postType === "post" && (React.createElement("meta", { property: "article:author", content: context.seo.fbAuthor })),
        context.seo.fbPublisher && infos.postType === "post" && (React.createElement("meta", { property: "article:publisher", content: context.seo.fbPublisher })),
        context.seo.fbAppID && (React.createElement("meta", { property: "fb:app_id", content: context.seo.fbAppID })),
        React.createElement("meta", { name: "twitter:title", content: twTitle }),
        React.createElement("meta", { name: "twitter:description", content: twDescription }),
        React.createElement("meta", { name: "twitter:card", content: context.seo.twCardStyle }),
        React.createElement("meta", { name: "twitter:image", content: image.src }),
        React.createElement("meta", { name: "twitter:image:width", content: image.width }),
        React.createElement("meta", { name: "twitter:image:height", content: image.height }),
        image.alt && React.createElement("meta", { name: "twitter:image:alt", content: image.alt }),
        context.seo.twCreator && (React.createElement("meta", { name: "twitter:creator", content: context.seo.twCreator })),
        context.seo.twSite && (React.createElement("meta", { name: "twitter:site", content: context.seo.twSite })),
        context.seo.googleVerification.length && (React.createElement("meta", { name: "google-site-verification", content: context.seo.googleVerification })),
        context.seo.bingVerification.length && (React.createElement("meta", { name: "msvalidate.01", content: context.seo.bingVerification })),
        context.seo.yandexVerification.length && (React.createElement("meta", { name: "yandex-verification", content: context.seo.yandexVerification })),
        context.seo.baiduVerification.length && (React.createElement("meta", { name: "baidu-site-verification", content: context.seo.baiduVerification })),
        context.seo.pinterestVerification.length && (React.createElement("meta", { name: "p:domain_verify", content: context.seo.pinterestVerification })),
        React.createElement("script", { type: "application/ld+json" }, JSON.stringify({
            "@context": "https://schema.org",
            "@type": context.seo.knowledgeType.charAt(0).toUpperCase() +
                context.seo.knowledgeType.slice(1),
            url: context.seo.rootUrl,
            name: context.settings.general.title,
            logo: context.seo.rootUrl.slice(0, -1) +
                context.settings.general.themeSettings.siteLogo.localFile
                    .childImageSharp.gatsbyImageData.images.fallback.src,
        })),
        trackingScript.length &&
            trackingScript.map((script, index) => {
                return (React.createElement("script", { key: index, type: "text/javascript" }, script));
            }),
        trackingNoScript.length &&
            trackingNoScript.map((noscript, index) => {
                return React.createElement("noscript", { key: index }, noscript);
            })));
};
export default SEO;
